export default __webpack_public_path__ + "static/granular-conversion-time-distribution-dark-mode-0514b09bb114ec4f8b72038331bb6b72.png";